import React from 'react';

const IndustryComparison = () => {
  return <div>IndustryComparison</div>;
};

export default IndustryComparison;
